import { useMemo } from 'react';

import { ChartOptions } from 'chart.js';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';

export function useDashboardTransactionsDynamicSummaryChartOptions(
  currency: string,
): ChartOptions<'bar'> {
  const translate = useTypedTranslate();

  return useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      resizeDelay: 100,
      scales: {
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        tooltip: {
          backgroundColor: 'rgba(97, 97, 97, 0.9)',
          displayColors: false,
        },
        legend: {
          labels: {
            boxWidth: 16,
            boxHeight: 16,
            padding: 16,
          },
        },
        currencyLegend: {
          text: translate('app.dashboard.transactionsDynamicSummary.currency', { currency }),
          gap: 16,
        },
      },
    }),
    [currency, translate],
  );
}
